import * as Actions from '../actions';
import moment from 'moment'

const initialState = {
    companyList: [],
    currentCompany: {},
    isCompanyLoaded: false,
    relatedMajorList: [],
    allCourses: [],
    allModules: [],
    allCompanies: [],
    allLessons: [],
    events: [],
    scheduledCourses: [],
    coursePreviewData: [],
    modulePreviewData: [],
    newEventCount: 0,
    dayEvents: [],
    unscheduledCourses: [],
    selectedEventData: {
        selected_calendar_day_id: 0,
        selected_calendar_module_id: 0,
        selected_calendar_course_id: 0
    },
    addUnscheduledDialog: false,
    companyAuthList: [],
    deleteInfo: {
        majors: [],
        users: [],
        courses: [],
        events: [],
        deleteAllowed: false
    }
}

const companyReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    companyList: action.payload
                }
            }
        case (Actions.UPDATE_COMPANY_FORM):
            {
                return {
                    ...state,
                    currentCompany: { ...state.currentCompany, ...action.payload }
                }
            }
        case (Actions.GET_COMPANY):
            {
                return {
                    ...state,
                    currentCompany: { ...action.payload, company_loaded: true }
                }
            }
        case (Actions.UPDATE_COMPANY_LOADED):
            {
                return {
                    ...state,
                    isCompanyLoaded: action.payload
                }
            }

        case (Actions.DELETE_COMPANY):
            {
                const newCompanyList = state.companyList.filter(company => company.company_id !== action.payload)
                return {
                    ...state,
                    currentCompany: { company_loaded: false },
                    companyList: newCompanyList
                };
            }

        case (Actions.GET_ALL_MAJORS):
            {
                return {
                    ...state,
                    allMajors: action.payload
                }
            }
        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    relatedMajorList: action.payload.majors,
                    deleteInfo: action.payload
                }
            }

        case (Actions.GET_SCHEDULED_COURSES):
            {
                return {
                    ...state,
                    scheduledCourses: action.payload
                }
            }
        case (Actions.TOGGLE_MAJOR):
            {
                if (action.payload.action_type === 'ADD') {
                    let newMajor = state.allMajors.filter((major) => major.major_id === action.payload.major.id)
                    return {
                        ...state,
                        relatedMajorList: state.relatedMajorList.concat(newMajor)
                    }
                }
                else {
                    return {
                        ...state,
                        relatedMajorList: state.relatedMajorList.filter((major) => major.major_id !== action.payload.major.id)
                    }
                }
            }

        case (Actions.GET_ALL_COURSES):
            {   
                return {   
                    ...state,
                    allCourses: action.payload
                }
            }
        case (Actions.GET_ALL_MODULES):
            {
                return {
                    ...state,
                    allModules: action.payload.moduleList
                }
            }
        case (Actions.GET_ALL_LESSONS):
            {
                return {
                    ...state,
                    allLessons: action.payload
                }
            }
        case (Actions.GET_COURSE_PREVIEW):
            {
                if (state.coursePreviewData.filter(c => c.course_id === action.payload.course_id).length > 0) {
                    return { ...state }
                }
                return {
                    ...state,
                    coursePreviewData: state.coursePreviewData.concat(action.payload.lessons)
                }
            }
        case (Actions.GET_MODULE_PREVIEW):
            {
                if (state.modulePreviewData.filter(m => m.module_id === action.payload.module_id).length > 0) {
                    return { ...state }
                }
                return {
                    ...state,
                    modulePreviewData: state.modulePreviewData.concat(action.payload.lessons)
                }
            }
        case (Actions.GET_SAVED_EVENTS):
            let getEventType = (course_id, module_id) => {
                if (course_id) {
                    return 'Course'
                }
                else if (module_id) {
                    return 'Module'
                }
                return 'Lesson'
            }
            {
                return {
                    ...state,
                    events: action.payload.map(lesson => {
                        let newDate = new Date(moment(lesson.LessonDate).format('YYYY-MM-DD HH:mm:ss'))
                        // let endTime = new Date(moment(lesson.Date).add(4,'hours').format('YYYY-MM-DD HH:mm:ss'))
                        return {
                            // Event object format for React Calendar to read
                            id: lesson.company_calendar_day_id,
                            title: lesson.LessonName,
                            allDay: true,
                            start: newDate,
                            end: newDate,
                            //custom event component info
                            courseName: lesson.CourseName,
                            eventType: 'existingEvent' + getEventType(lesson.company_calendar_course_id, lesson.company_calendar_module_id),
                            company_calendar_day_id: lesson.company_calendar_day_id,
                            company_calendar_course_id: lesson.company_calendar_course_id,
                            company_calendar_module_id: lesson.company_calendar_module_id,
                            selected: false,
                            color: lesson.Color,
                            // Information needed to save company calendar
                            course_lesson_rel_id: lesson.course_lesson_rel_id,
                            course_id: lesson.course_id,
                            module_id: lesson.module_id,
                            lesson_id: lesson.lesson_id,
                            studentCount: lesson.StudentCount
                        }
                    })
                }
            }

        case (Actions.HANDLE_EVENT_SELECT):
            {

                if (action.payload.course_id === 0 && action.payload.module_id === 0) {
                    return {
                        ...state,
                        events: state.events.map(event => {
                            if (event.company_calendar_day_id === action.payload.lesson_id) {
                                return {
                                    ...event,
                                    selected: true
                                }
                            }
                            return {
                                ...event,
                                selected: false
                            }
                        })
                    }
                }

                if (action.payload.module_id === 0) {
                    return {
                        ...state,
                        events: state.events.map(event => {
                            if (event.company_calendar_course_id === action.payload.course_id) {
                                return {
                                    ...event,
                                    selected: true
                                }
                            }
                            return {
                                ...event,
                                selected: false
                            }
                        })
                    }
                }
                else {
                    return {
                        ...state,
                        events: state.events.map(event => {
                            if (event.company_calendar_module_id === action.payload.module_id) {
                                return {
                                    ...event,
                                    selected: true
                                }
                            }
                            return {
                                ...event,
                                selected: false
                            }
                        })
                    }
                }


            }
        case (Actions.GET_DAY_EVENTS):
            {
                return {
                    ...state,
                    dayEvents: action.payload.map(event => {
                        return {
                            ...event,
                            id: event.company_calendar_event_id,
                            allDay: false,
                            start: new Date(event.StartTime),
                            end: new Date(event.EndTime),
                            test: 'string'
                        }
                    }),
                    events: state.events.map(event => {
                        return {
                            ...event,
                            selected: false
                        }
                    })
                }
            }

        case (Actions.TOGGLE_UNSCHEDULED_ADD_DIALOG):
            {
                return {
                    ...state,
                    addUnscheduledDialog: action.payload
                }
            }

        case (Actions.GET_UNSCHEDULED_COURSES):
            {
                return {
                    ...state,
                    unscheduledCourses: action.payload
                }    
            }
        case (Actions.GET_COMPANY_AUTH_LIST):
            {
                return {
                    ...state,
                    companyAuthList: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default companyReducer;


// WEBPACK FOOTER //
// src/main/content/company/store/reducers/company.reducer.js